export default __webpack_public_path__ + "static/media/factory__53.bc244c8c.jpg";